/** @format */

import { geoLocationStateConstants } from './actions';
import { reducerDebug } from '../../core/debug';
import { GeoLocationStateCollectionInterface } from '../../interfaces/platform/GeoLocationStateInterface';

export type GeoLocationStateReducersType = {
    type: string;
    collections: Array<GeoLocationStateCollectionInterface>;
    selectedValue?: string;
    valueChange?: boolean;
};

export const geoLocationStateReducers = (state = {}, action: GeoLocationStateReducersType): object => {
    reducerDebug('GeoLocationState reducer: ' + action.type);
    switch (action.type) {
        case geoLocationStateConstants.LIST:
        case geoLocationStateConstants.SELECT_CHANGE:
            return {
                ...state,
                ...action,
            };
        default:
            return { ...state };
    }
};
